export default class FormValidation {
  constructor(settings = { $form: $() }) {
    this.settings = settings;
    this.options = {
      activeClass: 'js-validation--init',
      $invalid: '.js-validation--invalid',
      $success: '.js-validation--success',
      $preloader: '.js-validation--preloader',
    };

    this.$element = settings.$form;
  }

  init() {
    let validationData = {
      $invalid: null,
      $success: null,
      $successResponseSelector: '.js-validation--success-response',
      $invalidResponseSelector: '#nc_modal_status',
      $preloader: null,
    };
    let validationSettings = [];
    const $this = this.$element;
    let $invalid = this.$element.find(this.options.$invalid);
    let $success = this.$element.find(this.options.$success);
    let $preloader = this.$element.find(this.options.$preloader);

    validationData = Object.assign(validationData, $this.data('validation'));

    if (validationData.$invalid !== null) $invalid = $(validationData.$invalid);
    if (validationData.$success !== null) $success = $(validationData.$success);
    if (validationData.$preloader !== null) $preloader = $(validationData.$preloader);

    if ($this.data('validation-settings')) validationSettings = $this.data('validation-settings');

    // действия если не поля заполнены верно
    validationSettings.invalidHandler = () => {
      $this.ajaxSubmit({
        data: { isNaked: 1 },
        success(response, status, xhr, Form) {
          const $form = $(Form);
          const $invalidResponse = $(response);
          const $responseWarnText = $invalidResponse.filter('.warnText');

          if ($responseWarnText.length && $responseWarnText.length !== false) {
            if ($invalid.length) $invalid.addClass('--active').html($responseWarnText);
            else $form.find('.warnText').html($responseWarnText);
          } else if ($invalid.length) $invalid.addClass('--active').html($invalidResponse);
          else $form.find('.warnText').html($invalidResponse);
        },
      });
    };

    // действия если все поля заполнены верно
    validationSettings.submitHandler = (form) => {
      const $form = $(form);
      const $buttonSubmit = $form.find('.js-validation--button-submit');
      let buttonSubmitTextCurrent = '';

      // заблокировать кнопку отправить
      if ($buttonSubmit.length) {
        const buttonSubmitTextReplace = $buttonSubmit.data('text-submit') || 'Отправка…';
        buttonSubmitTextCurrent = $buttonSubmit.html();

        $buttonSubmit.prop('disabled', true).html(buttonSubmitTextReplace);
      }

      if (validationData.ajax !== 'false') {
        $(form).ajaxSubmit({
          data: { isNaked: 1 },
          beforeSubmit() {
            // показать загрузку
            if ($preloader.length) {
              $preloader.show();
            }
          },
          success(response) {
            const $response = $(response);

            // записать ответ если сервер блокирует
            let $invalidResponse = $response.find(validationData.$invalidResponseSelector);
            if ($response.filter(validationData.$invalidResponseSelector).length) {
              $invalidResponse = $response.filter(validationData.$invalidResponseSelector);
            }

            // записать ответ если сервер одобряет
            let $successResponse = $response.find(validationData.$successResponseSelector);
            if ($response.filter(validationData.$successResponseSelector).length) {
              $successResponse = $response.filter(validationData.$successResponseSelector);
            }

            // показать ответ
            if ($invalid.length && $invalidResponse.length) {
              $invalid.addClass('--active').html($invalidResponse);
            } else if ($success.length && $successResponse.length) {
              $success.addClass('--active').html($successResponse);
            }

            // разблокировать кнопку отправить
            if ($buttonSubmit.length) {
              $buttonSubmit.prop('disabled', false).html(buttonSubmitTextCurrent);
            }

            // изменить адресную строку
            if (validationData.history) {
              history.pushState(
                null,
                null,
                `${$(form).attr('action')}?${$(form).formSerialize()}`,
              );
            }

            // скрыть загрузку
            if ($preloader.length) {
              $preloader.hide();
            }
          },
        });
      }
    };

    $this.addClass(this.options.activeClass).validate(validationSettings);
  }

  render() {
    if (this.$element.length && this.$element.hasClass(this.options.activeClass) === false) {
      this.init();
    }
    return this;
  }
}
